<script>
    export let display = "inline-block";
    export let maxWidth = '100px';
    export let mobileMaxWidth = '100px';
    export let height = '25px';
    export let mobileHeight = '25px';
    export let borderRadius = '10px';
    export let gradientColor = 'var(--color-gray-600)';
    export let background = 'var(--color-gray-500)';
    export let margin = '0';

    $: styles = `
        width: 100%;
        display: ${display};
        border-radius: ${borderRadius};
        margin: ${margin};

        --loader-background: ${background};
        --gradient-background: ${gradientColor};
        --width: ${maxWidth};
        --mWidth: ${mobileMaxWidth};
        --height: ${height};
        --mHeight: ${mobileHeight};
    `
</script>

<div class="loader-skeleton" style={styles}></div>

<style lang="less">
    .loader-skeleton {
        background: var(--loader-background);
        position: relative;
        overflow: hidden;
        max-width: var(--width);
        height: var(--height);

        @media screen and (max-width: 768px) {
            max-width: var(--mWidth);
            height: var(--mHeight);
        }

        &:before {
            content: '';
            position: absolute;
            width: 200%;
            height: 100%;
            background: linear-gradient(100deg, rgba(0,0,0,0) 0%, var(--gradient-background) 50%, rgba(0,0,0,0) 100%);
            animation-name: slideRight;
            animation-duration: 1.5s;
            animation-iteration-count: infinite;
        }
    }
</style>